<app-load-error *ngIf="loadError" [loadError]="loadError">

</app-load-error>


<div #chartTarget>

</div>